import { FiltersType } from 'features/SearchResults/components/Filters/SkillFilters';

export const hasEveryFilterEmpty = (structure: FiltersType): boolean =>
  structure.every((element) => element.filters.length === 0);
